import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ProfileSurveyObservation } from '../../../class/profile-survey-observation';
import { ProfileSurveyObservationService } from '../../../service/profile-survey-observation/profile-survey-observation.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { ProfileSurvey } from '../../../class/profile-survey';
import { formatDateWithoutHour } from '../../../../../theme/functions/formatDateWithoutHour.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-profile-survey-observation',
  templateUrl: './new-profile-survey-observation.component.html',
  styleUrls: ['./new-profile-survey-observation.component.scss']
})
export class NewProfileSurveyObservationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: ProfileSurveyObservation;
    @Input() profileSurvey: ProfileSurvey;
    public promiseForm: Promise<any>;
    public formProfileSurveyObservation: FormGroup;

    public activated: AbstractControl;
    public date: AbstractControl;
    public observation: AbstractControl;

    public es: any;

    public optionsSelectionCompetence: any[];

    constructor(
        fb: FormBuilder,
        public companyService: ProfileSurveyObservationService,
        public translate: TranslateService,
        private ngZone: NgZone) {

        this.es = calendarES();

        this.formProfileSurveyObservation = fb.group({
            'date': [''],
            'observation': [''],
            'activated': [''],
        });

        this.date = this.formProfileSurveyObservation.controls['date'];
        this.observation = this.formProfileSurveyObservation.controls['observation'];
        this.activated = this.formProfileSurveyObservation.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.date.setValue(new Date(this.edit.date));
            this.observation.setValue(this.edit.observation);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelProfileSurveyObservation () {
        this.formProfileSurveyObservation.reset();
        this.close.emit(true);
    }

    public newProfileSurveyObservation(values: ProfileSurveyObservation) {
        const param = {
            'date': formatDateWithoutHour(values.date),
            'observation': values.observation,
            'profile_survey_id': this.profileSurvey.id
        };
        if (values && this.formProfileSurveyObservation.valid) {
            const promise = (this.edit) ?
                this.companyService.updateProfileSurveyObservation(this.edit.id, param)
                :
                this.companyService.newProfileSurveyObservation(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msg.emit( { severity: 'success', summary: res  } );
                        this.formProfileSurveyObservation.reset();
                    });
                },
                error => {
                    this.msg.emit( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/profile-survey-observations/new-profile-survey-observation/new-profile-survey-observation.component.ts